import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

// Import required Swiper modules
import { Autoplay, Pagination } from "swiper/modules";

const HomeBanner = () => {
  return (
    <div
      className="home-banner-containeraa   container-fluid"
      style={{ overflow: "hidden" }}
    >
      <Swiper
        spaceBetween={0}
        centeredSlides={true}
        autoplay={{
          delay: 3000, // 3 seconds delay for autoplay
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        // navigation={true}
        modules={[Autoplay, Pagination]}
        className="mySwiper home-banner-swiper m-0 w-100"
      >
        {/* First Slide */}
        <SwiperSlide className="mt-5">
          {/* The main background image for the entire slide */}
          {/* IMPORTANT: Ensure 'overall_background.png' exists in public/images/ */}
          <div
            className="slide-inner-wrapper d-flex justify-content-start align-items-center"
            style={{ backgroundImage: `url('../images/images banner-02.jpg')` }}
          >
            {/*            
            <div className="squiggly-lines" style={{ backgroundImage: `url('/images/squiggly_lines.png')` }}></div>

         */}
            <div className="px-0 h-100 d-flex align-items-center justify-content-center position-relative z-2">
              <div className="row w-100 align-items-center m-0 ">
                <div className="d-flex flex-column  text-center h-100 w-100 px-3">
                  <h1 className="main-heading ml-25">
                    <span className="heading-part-2">Responsible,</span> <br />
                    <span className="heading-part-1">
                      efficient lending
                    </span>{" "}
                    <br />
                    <span className="heading-part-2">to the unbanked</span>
                  </h1>
                </div>

                {/* Right Section - Image (Bootstrap Column) */}
                {/* .d-flex .justify-content-center .align-items-center for centering the image within its column */}
                {/* <div className="col-md-6 d-flex justify-content-center align-items-center py-4 px-0">
                        
                        <img src="../images/cspImage.png" alt="Person with hands" className="column-image1 img-fluid p-0" />
                    </div> */}
              </div>
            </div>

            {/* Bottom Pattern and Logo - positioned absolutely over background and columns */}
            {/* <div className="bottom-design-container">
              <div className="hands-pattern" style={{ backgroundImage: `url('/images/hands_pattern.png')` }}></div>
              <img src="/images/heart_logo.png" alt="Heart Logo" className="heart-logo" />
            </div> */}
          </div>
        </SwiperSlide>

        {/* Second Slide (Duplicate and change content as needed) */}
        {/* <SwiperSlide>
            <div className="slide-inner-wrapper mt-5" style={{ backgroundImage: `url('../images/bg_image.png')` }}>
                <div className="squiggly-lines" style={{ backgroundImage: `url('/images/squiggly_lines.png')` }}></div>
                <div className="px-0 h-100 d-flex align-items-center position-relative z-2">
                    <div className="row w-100 align-items-center m-0">
                        <div className="col-md-6 d-flex flex-column justify-content-center py-4 px-5">
                            <p className="banner-Signline">
                            <img src="../images/banner-Sign.png" alt="Community support" className="p-0" />
                        </p>
                            <p className="subtitle">
                            <span className="subtitle-line"></span> One Gift. Endless Impact.
                        </p>
                        <h1 className="main-heading">
                        <span className="heading-part-1">Responsible,</span> <br />
                        <span className="heading-part-2">efficient lending</span> <br />
                        <span className="heading-part-2">to the unbanked</span>
                        </h1>
                           
                        </div>
                        <div className="col-md-6 py-4 px-0">
                            <img src="../images/cspImage.png" alt="Community support" className="column-image1 img-fluid p-0" />
                        </div>
                    </div>
                </div>
             
            </div>
        </SwiperSlide> */}
      </Swiper>
    </div>
  );
};

export default HomeBanner;
